import { render, staticRenderFns } from "./ProductContainerForm.vue?vue&type=template&id=a49e5db8&"
import script from "./ProductContainerForm.vue?vue&type=script&lang=ts&"
export * from "./ProductContainerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports